module.exports = __webpack_public_path__ + "static/img/大模型风险研判.4fa221c9.png";